export const CHECKOUT_URL = 'https://lacrosse-ready.impultienda.ar/checkout'

export const OFFER_ANCHOR = '#pricing'

export const CTA_LABEL = 'GET LACROSSE READY 360™ NOW'

export const PRICING_CTA_LABEL = 'YES, I WANT LACROSSE READY 360™'
